import { Injectable } from '@angular/core';
import { HttpClient }    from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from 'src/app/common/global';

@Injectable({ providedIn: 'root' })
export class NavigationCartService {
  lastOrder$!: Observable<any>;
  lastOrder: number = 0;

  constructor(private http: HttpClient) { }

  getLastOrder(): Observable<any> {
    if (!this.lastOrder$) {
      this.lastOrder$ = this.http
        .get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/last-order`, GlobalConstants.headersCentral)
        .pipe(
          shareReplay(1)
        );
    }
    return this.lastOrder$;
  }
}
